import React, { Component } from 'react';
import './styles.scss';

import { withContext } from '../../App';

class SMPWrapper extends Component {
  componentDidMount() {
    this.loadBump();
  }

  buildPlayerConfig() {
    return {
      responsive: true,
      product: 'news',
      autoplay: true,
      playlistObject: {
        holdingImageURL: "https://ichef.bbci.co.uk/images/ic/960xn/p079qctm.jpg",
        items: [{
            vpid: "p079qc73",
            duration: 60,
            kind: 'programme'
          }],
      },
      ui:{
        pictureInPicture: {
          enabled: false
        },
      }
    };
  }

  endCallback(){
    const { toggleModal } = this.props;
    const { markVideoWatched } = this.props.context;

    // Close the modal
    toggleModal();

    // Mark the video as watched in this session so that it doesn't appear again
    setTimeout(() => {
      markVideoWatched(true);
    }, 1500);
  }

  loadBump() {
    window.require(['bump-4'], (Bump) => {
      this.renderPlayer(Bump);
      this.smp.bind('ended', this.endCallback.bind(this));
    });
  }

  renderPlayer(Bump) {
    if (this.playerElement) {
      this.playerElement.innerHTML = '';
      const playerConfig = this.buildPlayerConfig();
      this.smp = Bump.player(this.playerElement, playerConfig);

      this.smp.load();
    }
  }

  render() {
    return (
      <div className="smpwrapper" style={{ position: 'relative' }}>
        <div className="media-player" ref={(elementRef) => { this.playerElement = elementRef; }} style={{ background: 'black' }} />
      </div>
    );
  }
}

export default withContext(SMPWrapper);
